import React, { useEffect, useRef, useState } from 'react'
import style from './illustrateMod.module.less'
import { switchProject } from '@/helpers/switchProject'
import palette from '@/helpers/palette'
import { showModal } from '@/share/actions'
import {
  Form,
  Input,
  Button,
  Dropdown,
  Menu,
  Message,
} from '@arco-design/web-react'
import {
  getIllustrateTemAndList,
  removeIllustrate,
  saveIllustrate,
} from '@/model/documentEdit'
import {
  IconArrowLeft,
  IconArrowRight,
  IconMoreEdits,
  IconSuccessTip,
} from '@arco-iconbox/react-aidb-v2'
import { GetQueryValue } from '@/utils/common'
import { events } from '@/helpers/event-emitter'
import { ACTIONS } from '@/share/constants'
const FormItem = Form.Item
const TextArea = Input.TextArea
interface Props {
  paragraphSign: string
  top: number
  domId: string
  illustrateHas: boolean
  nodePos: number
  list: any
  onIsAllComplete: (isAllComplete: boolean) => void
  onFirstSubmit: (isFirst: boolean, list: any) => void
}

const IllustrateMod = (props: Props) => {
  const {
    paragraphSign,
    onFirstSubmit,
    domId,
    illustrateHas,
    nodePos,
    list,
    onIsAllComplete,
  } = props
  const [selectIllustrateList, setSelectIllustrateList] = useState(list)
  const [currentClassIndex, setCurrentClassIndex] = useState(0)
  const formRef = useRef()
  const [form] = Form.useForm()
  useEffect(() => {
    if (illustrateHas) {
      getParaIllustrateList()
    }
  }, [])

  useEffect(() => {
    const isAllComplete = selectIllustrateList.every((_) => _.canEdit == false)
    onIsAllComplete(isAllComplete)
  }, [selectIllustrateList])

  const getParaIllustrateList = async () => {
    const res = await getIllustrateTemAndList({
      className: paragraphSign,
      uuidDoc: GetQueryValue('uuid'),
    })

    if (res.data.success) {
      const newSelectIllustrateList = res.data.data.map((item) => {
        return {
          ...item,
          canEdit: false,
        }
      })
      setSelectIllustrateList(newSelectIllustrateList)
    }
  }

  const formItemLayout = {
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 17,
    },
  }
  const noLabelLayout = {
    wrapperCol: {
      span: 17,
      offset: 7,
    },
  }

  const addIllustrate = () => {
    showModal('AddIllustrateModal', {
      paragraphSign: paragraphSign,
      onSubmit: submitModalHandle,
      isFirstCreate: true,
      onConfirm: () => {
        console.log('tttt')
      },
    })
  }

  const submitModalHandle = (list) => {
    const newList = list.map((item) => {
      return {
        ...item,
        canEdit: true,
      }
    })

    onFirstSubmit(true, newList)
    setSelectIllustrateList(newList)
  }

  const formSubmitHandle = async (values) => {
    const list = selectIllustrateList[currentClassIndex].fields.map((item) => ({
      ...item,
      value: values[item.text] || '', // Add the value property based on the text property
    }))

    const newSelectIllustrateList = selectIllustrateList.map((item, index) => {
      if (index == currentClassIndex) {
        return {
          ...item,
          list: list,
          canEdit: false,
        }
      } else {
        return {
          ...item,
        }
      }
    })
    setSelectIllustrateList(newSelectIllustrateList)
    const res = await saveIllustrate({
      className: paragraphSign,
      uuidDoc: GetQueryValue('uuid'),
      uuid: selectIllustrateList[currentClassIndex].uuid,
      list: list,
    })
    if (res.data.success) {
      events.emit(ACTIONS.ILLUSTRATE_BUBBLE_SUBMIT, {
        nodePos: nodePos,
        illustrateHasId: paragraphSign,
      })
    }
  }

  const updateIndex = (newIndex) => {
    setCurrentClassIndex(newIndex)
    // getCommentList(newIndex)
  }

  const preClassHandle = () => {
    if (currentClassIndex > 0) {
      updateIndex(currentClassIndex - 1)
    }
  }

  const nextClassHandle = () => {
    if (
      selectIllustrateList &&
      currentClassIndex < selectIllustrateList.length - 1
    ) {
      updateIndex(currentClassIndex + 1)
    }
  }

  const dropList = (
    <Menu className={'custom-dropdown'}>
      <div className={'dropdown-list'}>
        <Menu.Item key="1" onClick={() => onAddIllustrate()}>
          添加说明模版
        </Menu.Item>
        <Menu.Item
          key="2"
          disabled={
            selectIllustrateList &&
            selectIllustrateList[currentClassIndex]?.canEdit
          }
          onClick={() => onEditIllustrate()}>
          编辑说明
        </Menu.Item>
        <Menu.Item key="3" onClick={() => onRemoveIllustrate()}>
          删除说明
        </Menu.Item>
      </div>
    </Menu>
  )

  const onAddIllustrate = () => {
    showModal('AddIllustrateModal', {
      paragraphSign: paragraphSign,
      onSubmit: submitModalHandle,
      isFirstCreate: false,
      onConfirm: () => {
        console.log('tttt')
      },
    })
  }

  const onEditIllustrate = () => {
    const newSelectIllustrateList = selectIllustrateList.map((item, index) => {
      if (index == currentClassIndex) {
        return {
          ...item,
          fields: item.list,
          canEdit: true,
        }
      } else {
        return {
          ...item,
        }
      }
    })
    setSelectIllustrateList(newSelectIllustrateList)
  }

  const onRemoveIllustrate = async () => {
    if (!selectIllustrateList[currentClassIndex].canEdit) {
      const res = await removeIllustrate({
        className: paragraphSign,
        uuidDoc: GetQueryValue('uuid'),
        uuid: selectIllustrateList[currentClassIndex].uuid,
      })
      // if (res.data.success) {
      //   Message.success({
      //     icon: <IconSuccessTip useCurrentColor={false} />,
      //     content: `删除说明成功`,
      //   })
      // }
    }
    const newSelectIllustrateList = selectIllustrateList
      .slice(0, currentClassIndex)
      .concat(selectIllustrateList.slice(currentClassIndex + 1))
    if (newSelectIllustrateList.length == 0) {
      events.emit(ACTIONS.ILLUSTRATE_BUBBLE_EDIT_STATUS, {
        nodePos: nodePos,
        paragraphSign,
      })
    }

    if (currentClassIndex > 0) {
      preClassHandle()
    }
    setSelectIllustrateList(newSelectIllustrateList)

    Message.success({
      icon: <IconSuccessTip useCurrentColor={false} />,
      content: `删除说明成功`,
    })
  }

  return (
    <div className={style.illustrateWrapper}>
      {!illustrateHas && selectIllustrateList.length == 0 && (
        <div className={style.addWrapper}>
          <p className={style.text}>请添加模版，填写文档说明</p>
          <div
            className={style.addBtn}
            style={{
              border: !switchProject('DFZ')
                ? `1px solid ${palette.primary}`
                : `1px solid ${palette.primaryDFZ}`,
              color: !switchProject('DFZ')
                ? palette.primary
                : palette.primaryDFZ,
            }}
            onClick={addIllustrate}>
            文档说明模版
          </div>
        </div>
      )}
      {selectIllustrateList.length > 0 && (
        <div className={style.mainWrapper}>
          {/* <div className={style.topMod}>
            <div className={style.illustrateTitle}>
              {selectIllustrateList[currentClassIndex].name}
            </div>
          </div> */}
          <div className={style.topMod}>
            <div
              className={style.topLeftMod}
              style={{
                opacity: selectIllustrateList.length > 1 ? 1 : 0,
              }}>
              {/* {selectIllustrateList.length > 1 && ( */}
              <div style={{ display: 'flex' }}>
                <span onClick={preClassHandle}>
                  <IconArrowLeft />
                </span>
                <span style={{ margin: '0 10px' }}>
                  {currentClassIndex + 1}/{selectIllustrateList.length}
                </span>
                <span onClick={nextClassHandle}>
                  <IconArrowRight />
                </span>
              </div>
              {/* )} */}
            </div>
            {/* {selectIllustrateList.length > 0 && ( */}
            <div
              className={style.topRightMod}
              // onClick={cancelPostCommentHandle}
            >
              <Dropdown
                getPopupContainer={(triggerNode: HTMLElement) =>
                  triggerNode.parentNode as HTMLElement
                }
                droplist={dropList}
                position="br"
                // popupVisible={true}
                trigger={'click'}>
                <div className={`${style.more}`}>
                  <IconMoreEdits />
                </div>
              </Dropdown>
            </div>
            {/* )} */}
          </div>
          {/* <div className={style.contentMod}> */}
          {selectIllustrateList[currentClassIndex]?.canEdit ? (
            <Form
              ref={formRef}
              layout="vertical"
              autoComplete="off"
              {...formItemLayout}
              initialValues={{
                slider: 20,
                'a.b[0].c': ['b'],
              }}
              key={currentClassIndex}
              onSubmit={formSubmitHandle}
              // onValuesChange={formChangeHandle}
              scrollToFirstError>
              <div className={style.contentMod}>
                <div className={style.illustrateTitle}>
                  {selectIllustrateList[currentClassIndex].name}：
                </div>
                {selectIllustrateList[currentClassIndex].fields.map((item) => {
                  return (
                    <>
                      {item.fieldType == 'input' && (
                        <FormItem
                          key={item.code}
                          label={item.text}
                          field={item.text}
                          className={style.formItem}
                          rules={[{ required: true }]}
                          initialValue={item.value}>
                          <Input
                            placeholder={`请输入${item.text}`}
                            style={{
                              width: '240px',
                              height: '38px',
                              border: '1px solid #E0E0E0',
                              background: '#fff',
                            }}
                            height={38}
                          />
                        </FormItem>
                      )}

                      {item.fieldType == 'textarea' && (
                        <FormItem
                          key={item.code}
                          label={item.text}
                          field={item.text}
                          className={style.formItem}
                          rules={[{ required: true }]}
                          initialValue={item.value}>
                          <TextArea
                            placeholder={`请输入${item.text}`}
                            autoSize={{ minRows: 2, maxRows: 6 }}
                            style={{ width: 350 }}
                          />
                        </FormItem>
                      )}
                    </>
                  )
                })}
              </div>

              <Form.Item style={{ padding: '0 18px' }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: '240px' }}>
                  提交
                </Button>
              </Form.Item>
            </Form>
          ) : (
            <div className={style.contentMod}>
              <div className={style.illustrateTitle}>
                {selectIllustrateList[currentClassIndex].name}：
              </div>
              {selectIllustrateList[currentClassIndex].list.map((item) => {
                return (
                  <div key={item.code} className={style.noCanEditItem}>
                    <div className={style.noCanEditBox}>
                      <p className={style.title}>{item.text}</p>
                      <div className={style.content}>{item.value}</div>
                    </div>
                  </div>
                )
              })}
            </div>
          )}

          {/* </div> */}
          {/* <div className={style.bottomMod}>
            <div
              className={style.submitBtn}
              style={{
                //   border: !switchProject('DFZ')
                //     ? `1px solid ${palette.primary}`
                //     : `1px solid ${palette.primaryDFZ}`,
                background: !switchProject('DFZ')
                  ? palette.primary
                  : palette.primaryDFZ,
              }}
              onClick={submitHandle}>
              确定
            </div>
          </div> */}
        </div>
      )}
    </div>
  )
}

export default IllustrateMod
